import React from 'react';
import './WelcomeModal.css';

const WelcomeModal = ({ userData, onClose, onLogout }) => {
  return (
    <div className="welcome-modal-overlay">
      <div className="welcome-modal">
        <div className="welcome-modal-left">
          <div className="welcome-logo-container">
            <img src="/images/prologo.png" alt="ProCart India" className="welcome-logo" />
          </div>
          <div className="welcome-content">
            <h2>Welcome, {userData?.name || 'User'}</h2>
            <p>Your one-stop solution for electronics and components!</p>
            <p className="welcome-subtitle">You are currently logged in.</p>
          </div>
        </div>
        
        <div className="welcome-modal-right">
          <button className="welcome-close" onClick={onClose}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
              <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"/>
            </svg>
          </button>
          
          <div className="user-info">
            <div className="user-icon">
              <svg width="48" height="48" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
              </svg>
            </div>
            <div className="user-details">
              <h3>{userData?.name || 'User'}</h3>
              <p>{userData?.email || ''}</p>
              <p>{userData?.phone || ''}</p>
            </div>
          </div>
          
          <div className="welcome-actions">
            <button className="welcome-button primary" onClick={onClose}>
              Continue Shopping
            </button>
            <button className="welcome-button secondary" onClick={onLogout}>
              Logout
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WelcomeModal;